module.exports = __webpack_public_path__ + "media/forms/calendar25-2af8e7ff.png";